import { useEffect, useState } from "react";
import Footer from "../../components/layouts/footer";
import { API_URL, URLS } from "../../_config";
import {  IMAGE_FETCH_BACKEND_URL } from "../../_config/site_urls";
import { useRole, useToken } from "../../_common/hooks/authHook";
import { Controller, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Error from "../../components/formFieldError";
import Nav from "../../components/layouts/nav";
import { useMyAccountApi } from "../../_common/hooks/api/myAccountApiHook";
import Icon from "../../components/icon";
import Swal from "sweetalert2";

const MyAccount = () => {
    const myAccAPI = useMyAccountApi();
    const [profileDetails, setProfileDetails] = useState<any>(null);
    let tokenData: any = useToken();
    const userRole: any = useRole();
    const isMarketer = userRole === 'marketer';
    const [userimage, setUserimages] = useState<string | "/images/img/noUser.svg">("/images/img/noUser.svg");
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [commissionType, setCommissionType] = useState<number | null>(null);
    const [commissionValue, setCommissionValue] = useState<string | null>(null);

    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm();

    console.log('isMarketer:==', isMarketer);
    const getMyProfileDetails = async () => {
        try {
            const response = await fetch(API_URL.ACCOUNT.MY_ACCOUNT, {
                headers: { Authorization: `Bearer ${tokenData}` }
            });
            const resp = await response.json();
            setProfileDetails(resp.data);
            setUserimages(resp.data?.user?.avatar?.thumb);
            if (resp.data?.commission_type !== undefined) {
                setCommissionType(resp.data.commission_type);
                setCommissionValue(resp.data.commission_value);
            }
            let resetValues = {
                first_name: resp.data?.user?.first_name,
                last_name: resp.data?.user?.last_name,
                _umail: resp.data?.user?.email,
                phone: resp.data?.user?.phone,
                job_title: resp.data?.job_title,
                department: resp.data?.department,
            }
            reset(resetValues);

        } catch (error) {
            console.log('Error occurred while making the API request.');
            setProfileDetails([])
        }
    }

    useEffect(() => {
        getMyProfileDetails();
    }, [])


    const updateProfile = (params: any) => {
        return new Promise((resolve, reject) => {
            setBtnDisabled(true);
            myAccAPI.updateProfile(params, (message: any, resp: any) => {
                resolve(message)
                setBtnDisabled(false);
            }, (message: any, data: any) => {
                reject(message)
                setBtnDisabled(false);
                if (data) {
                    Object.keys(data).map((key) => { // key is the field name
                        setError(key, {
                            type: "manual",
                            message: data[key]
                        })
                    })
                }
            })



            // fetch(API_URL.ACCOUNT.MY_ACCOUNT_UPDATE, {
            //     method: 'PUT',
            //     headers: {
            //         'Content-Type': 'application/json',
            //         'Authorization': `Bearer ${tokenData}`
            //     },
            //     body: JSON.stringify(params),
            // })
            //     .then(response => response.json())
            //     .then(resp => {
            //         if (resp?.status == 200) { // Success
            //             resolve(resp.message);
            //         } else {
            //             reject(resp.message);
            //             const errorResp = resp?.data;
            //             if (errorResp) {
            //                 Object.keys(errorResp).map((key) => {
            //                     setError(key, {
            //                         type: "manual",
            //                         message: errorResp[key]
            //                     })
            //                 })
            //             }
            //         }
            //     })
            //     .catch(error => {
            //         // Handle error
            //         console.error('Error:', error);
            //         reject(error.message);
            //     });
        })
    }


    const fallbackCopy = (text: string, onSuccess: () => void) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
            document.execCommand('copy');
            onSuccess();
        } catch {
            toast.error('Could not copy. Please copy the URL manually.');
        }
        document.body.removeChild(textarea);
    };

    const handleCopyReferral = () => {
        if (!profileDetails?.referral_shortcode) return;

        const url = `${IMAGE_FETCH_BACKEND_URL}/go/${profileDetails.referral_shortcode}`;

        const showSuccess = () => {
            Swal.fire({
                icon: 'success',
                title: 'Copied!',
                text: 'Your referral URL has been copied to the clipboard.',
                timer: 2500,
                showConfirmButton: false,
            });
        };

        if (navigator.clipboard) {
            navigator.clipboard.writeText(url)
                .then(showSuccess)
                .catch(() => fallbackCopy(url, showSuccess));
        } else {
            fallbackCopy(url, showSuccess);
        }
    };

    const saveFormHandler = async (data: any) => {
        data.id = profileDetails?.user?.id;
        toast.promise(
            updateProfile(data), {
            loading: 'Updating Profile...',
            success: (msg: any) => {
                getMyProfileDetails();
                return <b>{msg}</b>
            },
            error: (msg: any) => { return <b>{msg}</b> },
        });
    }

    const updateAvatar = (params: any) => {
        return new Promise((resolve, reject) => {
            setBtnDisabled(true);
            fetch(API_URL.ACCOUNT.MY_AVATAR_UPDATE, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${tokenData}` },
                body: JSON.stringify(params),
            })
                .then(response => response.json())
                .then(resp => {
                    if (resp?.status == 200) { // Success 
                        resolve(resp.message);
                        setBtnDisabled(false);
                    } else {
                        reject(resp.message);
                        setBtnDisabled(false);
                    }
                })
                .catch(error => {
                    // Handle error
                    console.error('Error:', error);
                    reject(error.message);
                    setBtnDisabled(false);
                });
        })
    }

    const handleProfilePicChange = (event: any) => {
        // Access the selected file(s) from event.target.files
        const selectedFile = event.target.files[0];

        // Do something with the selected file, e.g., display its name 
        if (selectedFile) {
            const reader = new FileReader();

            reader.onloadend = () => {
                // Base64 string representation of the selected file
                const base64String = reader.result as string | null;
                if (base64String !== null) {
                    setUserimages(base64String);

                    toast.promise(
                        updateAvatar({ 'avatar': base64String }), {
                        loading: 'Uploading...',
                        success: (msg: any) => {
                            return <b>{msg}</b>
                        },
                        error: (msg: any) => { return <b>{msg}</b> },
                    });
                }

                // You can use the base64String as needed (e.g., set it in the state)
            };

            // Read the selected file as a Data URL (Base64)
            reader.readAsDataURL(selectedFile);
        }
    };

    return (

        <>
            <Nav />
            <div className="body-part gray-bg mt-105">
                <div className="container text-center">
                    <h2 className="page-title">Account <span>Information</span></h2>
                    <p className="tag-line">Manage your profile</p>

                    <div className="profile-box">
                        <div className="profile-box-title">
                            <div className="profile-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25" fill="none">
                                    <path d="M13 17C17.4183 17 21 13.4183 21 9C21 4.58172 17.4183 1 13 1C8.58172 1 5 4.58172 5 9C5 13.4183 8.58172 17 13 17Z" stroke="#D1D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M1 24C3.42125 19.8162 7.81875 17 13 17C18.1813 17 22.5787 19.8162 25 24" stroke="#D1D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                            <div className="profile-text">Your Profile</div>
                        </div>
                        <div className="profile-box-data">
                            <div className="profile-box-left">
                                <div className="profile-image">
                                    <span><img src={userimage} alt={profileDetails?.user?.full_name} title={profileDetails?.user?.full_name} /></span>
                                    <em><img src="/images/img/camera-icon.svg" alt="" />
                                        <Controller
                                            defaultValue={""}
                                            control={control}
                                            name="profilePic"
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                            }) => (
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        handleProfilePicChange(e);
                                                    }}
                                                />
                                            )}
                                        />
                                    </em>
                                </div>
                                <div className="profile-data">
                                    <h2>{(profileDetails?.user?.full_name) ?? 'Loading...'}</h2>
                                    <h3>{profileDetails?.user?.email}</h3>
                                </div>
                            </div>
                            <div className="profile-box-right">
                                <form onSubmit={handleSubmit(saveFormHandler)} >
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">First Name <span className="text-red-500">*</span></label>
                                                <Controller
                                                    defaultValue={""}
                                                    control={control}
                                                    name={`first_name`}
                                                    rules={{ required: 'This field is required' }}
                                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                        <input type="text" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="First Name" spellCheck="false" data-ms-editor="true" />
                                                    )}
                                                />
                                                <Error error={errors[`first_name`]} customClass="text-xs" />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">Last Name <span className="text-red-500">*</span></label>
                                                <Controller
                                                    defaultValue={""}
                                                    control={control}
                                                    name={`last_name`}
                                                    rules={{ required: 'This field is required' }}
                                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                        <input type="text" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="Last Name" spellCheck="false" data-ms-editor="true" />
                                                    )}
                                                />
                                                <Error error={errors[`last_name`]} customClass="text-xs" />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">Email <span className="text-red-500">*</span></label>
                                                <input type="text" value={profileDetails?.user?.email} className="form-control cursor-not-allowed" disabled style={{ background: '#f5f5f5' }} />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">Phone <span className="text-red-500">*</span></label>
                                                {/* <Controller
                                                    defaultValue={""}
                                                    control={control}
                                                    name={`phone`}
                                                    rules={{ required: 'This field is required' }}
                                                    // rules={{ required: 'This field is required', pattern: { value: /^[0-9]+$/, message: 'Invalid phone number' } }}
                                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                        <input type="number" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="Phone" spellCheck="false" data-ms-editor="true" />
                                                    )}
                                                /> */}
                                                <Controller
                                                    defaultValue={""}
                                                    control={control}
                                                    name={`phone`}
                                                    rules={{
                                                        required: "Phone is required.",
                                                        pattern: {
                                                            value: /^[0-9]{10}$/,
                                                            message: "Phone number must be 10 digits."
                                                        }
                                                    }}
                                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                        <input
                                                            type="text"
                                                            name={name}
                                                            onChange={(e) => {
                                                                const newValue = e.target.value.replace(/[^0-9]/g, '');
                                                                onChange(newValue);
                                                            }}
                                                            value={value}
                                                            className="form-control"
                                                            autoComplete="off"
                                                            placeholder="Enter phone"
                                                            spellCheck="false"
                                                            data-ms-editor="true"
                                                            maxLength={10} // This ensures no more than 10 characters can be entered
                                                        />
                                                    )}
                                                />
                                                <Error error={errors[`phone`]} customClass="text-xs" />
                                            </div>
                                        </div>
                                        {!isMarketer && <>
                                        <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">Job Title <span className="text-red-500">*</span></label>
                                                <Controller
                                                    defaultValue={""}
                                                    control={control}
                                                    name={`job_title`}
                                                    rules={{ required: 'This field is required' }}
                                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                        <input type="text" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="Job Title" spellCheck="false" data-ms-editor="true" />
                                                    )}
                                                />
                                                <Error error={errors[`job_title`]} customClass="text-xs" />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">Your Department <span className="text-red-500">*</span></label>
                                                <Controller
                                                    defaultValue={""}
                                                    control={control}
                                                    name={`department`}
                                                    rules={{ required: 'This field is required' }}
                                                    render={({ field: { onChange, onBlur, value, name, ref } }) => (
                                                        <input type="text" name={name} onChange={onChange} value={value} className="form-control" autoComplete="off" placeholder="Your Department" spellCheck="false" data-ms-editor="true" />
                                                    )}
                                                />
                                                <Error error={errors[`department`]} customClass="text-xs" />
                                            </div>
                                        </div>
                                        </>}
                                        {isMarketer && <>
                                        {/* <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">Commission Type</label>
                                                <input type="text" className="form-control cursor-not-allowed" value={commissionType === 1 ? 'Fixed' : commissionType === 2 ? 'Percentage' : '—'} disabled />
                                            </div>
                                        </div> */}
                                        <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">Commission Value ({commissionType === 1 ? 'Fixed' : commissionType === 2 ? '%' : '—'})</label>
                                                <input type="text" className="form-control cursor-not-allowed" value={commissionValue ?? '—'} disabled style={{ background: '#f5f5f5' }} />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3 float-input">
                                                <label className="form-label">Referral Code</label>
                                                <div style={{ position: 'relative' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control cursor-not-allowed"
                                                        value={IMAGE_FETCH_BACKEND_URL + '/go/' + (profileDetails?.referral_shortcode ?? '—')}
                                                        disabled
                                                        style={{ background: '#f5f5f5', paddingRight: '40px' }}
                                                    />
                                                    <span
                                                        onClick={handleCopyReferral}
                                                        style={{
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            cursor: profileDetails?.referral_shortcode ? 'pointer' : 'default',
                                                            opacity: profileDetails?.referral_shortcode ? 1 : 0.4,
                                                        }}
                                                    >
                                                        <Icon name="copy" />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        </>}
                                    </div>
                                    <div className="btn-wrap">
                                        <button type="submit" className="update-btn" disabled={btnDisabled} style={{ cursor: (btnDisabled) ? 'not-allowed' : '' }}>Update</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default MyAccount; 